
angular.module("ainapp")
    .controller("ApprovalcompanyExpenseController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {



            $scope.PageName = "Company Expense Approvals";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.IsAdmin = false;
            if ($scope.TokenInfo.Role == "Admin" || $scope.TokenInfo.Role == "admin" || $scope.TokenInfo.Role == "SA" || $scope.TokenInfo.Role == "CA" || $scope.TokenInfo.Role == "0") {
                $scope.IsAdmin = true;
            }

 
            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };

                $scope.Columns = [

                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                                            },
                    {
                        field: "VoucherNumber",
                        title: "Voucher Number",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                                            },
                    {
                        field: "Account.Name",
                        title: "Account Name",
                        headerTemplate: "{{LanguageData.account_name}}",
                                            },
                    {
                        field: "SubAccounts",
                        title: "Sub Accounts",
                     },
                    {
                        field: "SubTotal",
                        title: "Sub Total",
                        headerTemplate: "{{LanguageData.sub_total}}",
                        template: "<div style='text-align: right'>#=kendo.toString(SubTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalTax",
                        title: "Total Tax",
                        headerTemplate: "{{LanguageData.total_tax}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",

                                            },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        headerTemplate: "{{LanguageData.GrandTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },
                    {
                        field: "CreatedDate",
                        template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Created Date"
                                            },

                    {
                        field: "CreatedBy.UserName",
                        title: "Created By"
                                            }, {
                        field: "Remarks",
                        title: "Remarks"
                                            },

                                        ];

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Company Expense").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            //  template: "<a ng-repeat='cc in dataItem.CreditNoteSRCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                            width: '100px',
                            //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                        }
                        $scope.Columns.push(clm);
                    })

                    var options = {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template:`<div ng-include="'templates/common/approvalButtons.html'"></div>`,
                        width: '200px'
                    };

                    $scope.Columns.push(options);

                    $scope.loadKendo();
                });

            }
            $scope.init();


            $scope.loadKendo = function () {

                $scope.SalesSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {
                            o.data.Keyword = $scope.filter.Keyword;
                            MainService.CompanyExpenseForApprovals(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success(false);
                                toastr.error($scope.NetworkErrorLan);
                            })
                        }
                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.CompanyExpenseCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },
                                SubAccounts: {
                                    type: "string",
                                },

                                "Account.Name": {
                                    type: "string",
                                },
                                SubTotal: {
                                    type: "number",
                                },
                                TotalTax: {
                                    type: "number",
                                },
                                GrandTotal: {
                                    type: "number",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "Remarks": {
                                    type: "string",
                                }
                            }
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.SalesFactory = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 550,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.SalesSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: $scope.Columns,
                };
            }

            $scope.Edit = function (data) {
                $state.go("editcompanyExpense", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

             $scope.Approve = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ApproveCompanyExpense(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Resubmit = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ResubmitCompanyExpense(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.RejectData = {
                VoucherId: "",
                Reason: "",
            };

            $scope.Reject = function (data) {
                $scope.RejectData = {
                    VoucherId: data.Id,
                    Reason: "",
                };

                $('#rejectModal').modal('show');
            }

            $scope.ConfirmReject = function () {

                if ($scope.RejectData.Reason == "") {
                    toastr.warning("Enter Reason");
                } else {
                    $scope.load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.RejectCompanyExpense($scope.RejectData).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.refresh();
                            $('#rejectModal').modal('hide');
                        } else {
                            toastr.warning(response.data);
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function () {
                        toastr.error("NetworkError");
                        $scope.working = false;
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }

            $scope.View = function (data) {
                // $state.go("viewcompanyExpense", {
                //     VoucherId: data.Id
                // })

                var url = $state.href('viewcompanyExpense', {
                    VoucherId: data.Id
                });
                window.open(url, '_blank');
            }



        }])
